import React from 'react';
import { ROUTES } from '../../common/constants/routes';
import { SignIn } from '@clerk/clerk-react';

const ClerkLogIn = () => {
  return (
    <React.Fragment>
      <div>
        <SignIn signUpUrl={ROUTES.SIGN_UP} forceRedirectUrl={localStorage.getItem('location')} />
      </div>
    </React.Fragment>
  );
};

export default ClerkLogIn;
